import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { useDispatch, useSelector } from 'react-redux';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CircularProgress from '@material-ui/core/CircularProgress';

import * as constants from '../../../constants/constant';
import { useBasicInfoStyles, basicInfoStyles } from './styles';
import { UserPortalContext } from '../../../context/appcontext';
import ErrorScreenMessage from '../../ErrorScreenMessage/ErrorScreenMessage';
import { getItemBasicInfo } from '../../../redux/actions/itemDrillDownActions';

function ItemBasicInfo({ weekFilter, category, itemNum, startDate, endDate }) {
	const classes = useBasicInfoStyles();
	const dispatch = useDispatch();
	const portalUserContext = React.useContext(UserPortalContext);
	const { basicInfoData, basicInfoErrorCode, basicInfoLoading } = useSelector(
		(state) => state.itemDrillDownReducer
	);
	const selectedView = useSelector(
		(state) => state.appGuideReducer.selectedView
	);

	React.useEffect(() => {
		if (itemNum) {
			const params = {
				categoryId: '-1',
				period: weekFilter,
				portalUserContext,
				itemNum,
				startDate,
				endDate,
			};
			dispatch(getItemBasicInfo(params));
		}
	}, [weekFilter, category, itemNum, startDate, endDate, selectedView]);

	if (!basicInfoLoading) {
		if (
			(!basicInfoData?.catName && basicInfoErrorCode === 0) ||
			basicInfoErrorCode === 204
		) {
			return (
				<ErrorScreenMessage
					errorMsg={constants.DATA_NOT_AVAILABLE}
					chartTitle={'Basic info'}
				/>
			);
		}
		if (basicInfoErrorCode !== 0) {
			return (
				<ErrorScreenMessage
					errorMsg={constants.DATA_NOT_LOADING_MSG}
					chartTitle={'Basic info'}
				/>
			);
		}
	}

	return (
		<Fragment>
			{basicInfoLoading ? (
				<Box className={classes.loader}>
					<CircularProgress className={classes.circularProgress} />
				</Box>
			) : (
				<Box>
					<Box className={classes.breadCrumb}>
						<Breadcrumbs
							separator={<NavigateNextIcon fontSize="small" />}
							aria-label="breadcrumb">
							<Typography style={basicInfoStyles.breadCrumb}>
								{/* Category */}
								{basicInfoData.catName}
							</Typography>
							<Typography style={basicInfoStyles.breadCrumb}>
								{/* Sub-category */}
								{basicInfoData.subCatName}
							</Typography>
						</Breadcrumbs>
					</Box>
					<Box className={classes.info}>
						<Typography style={basicInfoStyles.itemName}>
							{/* Item name */}
							{basicInfoData.itemName}
						</Typography>
						{basicInfoData.itemId && (
							<Fragment>
								<Typography style={basicInfoStyles.label}>Item#</Typography>
								<Typography style={basicInfoStyles.value}>
									{basicInfoData.itemId}
								</Typography>
							</Fragment>
						)}
						{basicInfoData.upc && (
							<Fragment>
								<Typography style={basicInfoStyles.label}>UPC</Typography>
								<Typography style={basicInfoStyles.value}>
									{basicInfoData.upc}
								</Typography>
							</Fragment>
						)}
						{basicInfoData.brandName && (
							<Fragment>
								<Typography style={basicInfoStyles.label}>Brand</Typography>
								<Typography style={basicInfoStyles.value}>
									{basicInfoData.brandName}
								</Typography>
							</Fragment>
						)}
					</Box>
					<Divider />
					<Box className={classes.supplier}>
						{basicInfoData.supplier && (
							<Fragment>
								<Typography style={basicInfoStyles.supplierName}>
									Supplied by - {basicInfoData.supplier}{' '}
									{basicInfoData.supplierId}
								</Typography>
							</Fragment>
						)}
					</Box>
				</Box>
			)}
		</Fragment>
	);
}

ItemBasicInfo.propTypes = {
	itemNum: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	weekFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	category: PropTypes.string,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
};

export default ItemBasicInfo;
